// Phones: the document popups (quote, proforma, invoice, PO) show ONE pane at a time,
// the form or the generated preview, at full height. Side by side they left the form
// about a third of the popup with its fields cut off, and the preview an empty box.
// From lg up both panes show together and this switch is hidden.

export type Pane = 'edit' | 'preview';

export function PaneSwitch({ pane, onChange, previewReady, editLabel = 'Edit' }: {
  pane: Pane;
  onChange: (pane: Pane) => void;
  /** Preview is disabled until there is a document to show. */
  previewReady: boolean;
  editLabel?: string;
}) {
  return (
    <div className="flex gap-1 border-b border-border bg-background px-3 py-2 lg:hidden" role="tablist" aria-label="View">
      {(['edit', 'preview'] as const).map((k) => (
        <button
          key={k}
          type="button"
          role="tab"
          aria-selected={pane === k}
          disabled={k === 'preview' && !previewReady}
          title={k === 'preview' && !previewReady ? 'Generate the document first' : undefined}
          onClick={() => onChange(k)}
          className={`h-10 flex-1 rounded-md text-sm font-medium disabled:opacity-40 ${
            pane === k ? 'bg-muted text-foreground' : 'text-muted-foreground hover:bg-muted/50'
          }`}
        >
          {k === 'edit' ? editLabel : 'Preview'}
        </button>
      ))}
    </div>
  );
}
